import { Component } from '@theme/component';

class EscCollection extends Component {
  requiredRefs = ['collectionMain', 'hideFiltersText', 'showFiltersText'];

  #filtersVisible = true;

  connectedCallback() {
    super.connectedCallback();
  }

  toggleFilterVisibility() {
    this.#filtersVisible = !this.#filtersVisible;
    this.refs.collectionMain.classList.toggle('esc-collection__main--filters-hidden', !this.#filtersVisible);
    this.refs.hideFiltersText.classList.toggle('hidden', !this.#filtersVisible);
    this.refs.showFiltersText.classList.toggle('hidden', this.#filtersVisible);
  }

  openMobileFilters() {
    const mobileFilters = this.querySelector('esc-mobile-filters');
    mobileFilters?.open();
  }
}

if (!customElements.get('esc-collection')) {
    customElements.define('esc-collection', EscCollection);
}